// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__hMQzL","errors":"Errors_errors__2UcHc"};